import { getUsersByLocalId } from '../../../../../crud/users_api/users';
import { getMesasByLocalId } from '../../../../../crud/management_api/mesas';  
import { getAllPedidosType } from '../../../../../crud/configuration_api/pedidos_type';

export interface UsersOption {
  id: number;
  name: string;
}

export interface MesasOption {
  id: number;
  num: string;
}

export interface PedidoTypeOption {
  id: number;
  name: string;
}

export const getUsersOptions = async () => {
  const userContext = localStorage.getItem('user');
  const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
  const response = await getUsersByLocalId(localId);
  if (response) {
    const data = response.data;
    if (data) {
      const users: UsersOption[] = data.map((user: any) => ({
        id: user.user_id,
        name: user.username,
      }));
      return users;
    }
  }
  return [];
};

export const getMesasOptions = async () => {
  const userContext = localStorage.getItem('user');
  const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
  const response = await getMesasByLocalId(localId);
  if (response) {
    const data = response.data;
    if (data) {
      const mesas: MesasOption[] = data.map((mesa: any) => ({
        id: mesa.mesa_id,
        num: mesa.mesa_number,
      }));
      return mesas;
    }
  }
  return [];
};

export const getPedidosTypeOptions = async () => {
  const response = await getAllPedidosType();
  if (response) {
    const data = response.data;
    if (data) {
      const pedidoType: PedidoTypeOption[] = data.map((pedidosType: any) => ({
        id: pedidosType.pedido_type_id,
        name: pedidosType.pedido_type_name,
      }));
      return pedidoType;
    }
  }
  return [];
};
